const BASE_URL = 'https://compagnon-api.onrender.com';

const api = async (path, options = {}) => {
  const token = localStorage.getItem('compagnon_token');
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Erreur réseau' }));
    throw new Error(err.detail || 'Erreur');
  }
  return res;
};

export const authAPI = {
  signup: (data) => api('/auth/signup', { method: 'POST', body: JSON.stringify(data) }).then(r => r.json()),
  login: (email, password) => api('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }).then(r => r.json()),
  getProfil: (id) => api(`/auth/profil/${id}`).then(r => r.json()),
  updateProfil: (id, data) => api(`/auth/profil/${id}`, { method: 'PUT', body: JSON.stringify(data) }).then(r => r.json()),
  forgotPassword: (email) => api('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }).then(r => r.json()),
};

export const chatAPI = {
  send: (messages, artisan_id, conversation_id) =>
    api('/chat/', { method: 'POST', body: JSON.stringify({ messages, artisan_id, conversation_id }) }).then(r => r.json()),
  getConversations: (artisan_id) => api(`/chat/conversations/${artisan_id}`).then(r => r.json()),
  getMessages: (conversation_id) => api(`/chat/messages/${conversation_id}`).then(r => r.json()),
};

export const devisAPI = {
  generer: async (data) => {
    const token = localStorage.getItem('compagnon_token');
    const res = await fetch(`${BASE_URL}/devis/generer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: 'Erreur génération PDF' }));
      throw new Error(err.detail || 'Erreur génération PDF');
    }
    const blob = await res.blob();
    const documentId = res.headers.get('X-Document-Id') || null;
    const numero = res.headers.get('X-Document-Numero') || null;
    const montantTTC = res.headers.get('X-Montant-TTC') || null;
    return {
      url: URL.createObjectURL(blob),
      documentId,
      numero,
      montantTTC: montantTTC ? parseFloat(montantTTC) : null,
    };
  },

  envoyer: (data) => api('/devis/envoyer', {
    method: 'POST',
    body: JSON.stringify(data),
  }).then(r => r.json()),

  getListe: (artisan_id) => api(`/devis/documents/${artisan_id}`).then(r => r.json()),

  updateStatut: (doc_id, statut) => api(`/devis/documents/${doc_id}/statut`, {
    method: 'PUT',
    body: JSON.stringify({ statut }),
  }).then(r => r.json()),
};
